import { useQueryWithUserId, useRegionStore } from '@northladder/services';

import { COSMETIC_EVALUATION_API } from '../cosmeticEvaluationClient';

/**
 * This is to track validation query for the device assessment.
 */
const DEVICE_ASSESSMENT_VALIDATE_QUERY_KEY = 'device-validate-query-key';

interface IUseDeviceAssessmentValidationOptions {
  /**
   * The evaluationId/External Integration Identifier (EII) can be found in the
   * URL of the pandas web application. It is generated and added as a query
   * string in the URL.
   *
   * - Source: https://northladder.atlassian.net/wiki/spaces/BTS/pages/2472378369/Used+Device+Trade-In+Integration+for+Pandas+WebApp
   */
  evaluationId?: string;
  /**
   * Whether the query should be enabled or not.
   */
  isEnabled?: boolean;
}

/**
 * This hook validates the provided EII(External Integration Identifier) number
 * from the retail app assessment session.
 * - https://northladder.atlassian.net/wiki/spaces/BTS/pages/2472378369/Used+Device+Trade-In+Integration+for+Pandas+WebApp#Validate-EII
 */
export const useDeviceAssessmentValidationQuery = ({
  evaluationId = '',
  isEnabled,
}: IUseDeviceAssessmentValidationOptions) => {
  const baseURL = useRegionStore().tenantConfig?.apiBaseURL || '';

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [DEVICE_ASSESSMENT_VALIDATE_QUERY_KEY, evaluationId, baseURL],
    queryFn: () =>
      COSMETIC_EVALUATION_API.validateDeviceAssessmentSession(
        evaluationId,
        baseURL
      ),
    retry: false,
    enabled: !!isEnabled && !!evaluationId,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
